import React, { useMemo, useState } from "react";
import { backend_url } from "../../server";

const ServiceCard = ({ data }) => {
  const [showDetails, setShowDetails] = useState(false);
  const imageUrl = data?.bannerImage ? `${backend_url}${data.bannerImage}` : "";
  const title = data?.name || "Service";
  const description = useMemo(
    () => String(data?.description || "").trim(),
    [data?.description]
  );
  const price = Number(
    data?.discountPrice ?? data?.originalPrice ?? data?.price ?? 0
  );

  return (
    <div className="w-full rounded-xl h-[100%] border border-slate-200 bg-white p-4 shadow-sm transition hover:shadow-md flex flex-col justify-between">
      <div>
      <div className="h-[180px] w-full overflow-hidden rounded-lg bg-slate-50 flex items-center justify-center">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={title}
            className="h-full w-full object-contain"
          />
        ) : (
          <span className="text-sm text-slate-400">No image</span>
        )}
      </div>
      <h3 className="mt-3 text-base font-semibold text-slate-900 line-clamp-2">{title}</h3>
      <p className="mt-2 text-sm font-semibold text-[#38513b]">
        £{price.toFixed(2)}
      </p>
      </div>
      <div>
      <button
        type="button"
        onClick={() => setShowDetails(true)}
        className="mt-3 inline-flex items-center justify-center rounded-lg bg-[#38513b] px-4 py-2 text-sm font-medium text-white hover:bg-[#2f4232]"
      >
        View service
      </button>
      </div>
      {showDetails && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4">
          <div className="w-full max-w-lg rounded-xl bg-white shadow-xl">
            <div className="flex items-start justify-between border-b border-slate-200 px-5 py-4">
              <h4 className="text-lg font-semibold text-slate-900">{title}</h4>
              <button
                type="button"
                onClick={() => setShowDetails(false)}
                className="rounded-md px-2 py-1 text-slate-500 hover:bg-slate-100 hover:text-slate-700"
                aria-label="Close service details"
              >
                ✕
              </button>
            </div>
            <div className="px-5 py-4">
              <p className="text-sm text-slate-700 whitespace-pre-line">
                {description || "No description has been added for this service yet."}
              </p>
            </div>
            <div className="flex justify-end gap-2 border-t border-slate-200 px-5 py-4">
              <button
                type="button"
                onClick={() => setShowDetails(false)}
                className="inline-flex items-center justify-center rounded-lg bg-[#38513b] px-4 py-2 text-sm font-medium text-white hover:bg-[#2f4232]"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ServiceCard;
